import React, {Component} from "react";
import {Upload, Button, Input, Switch} from "antd";
import ImgUpload from "./ImgUpload/ImgUpload";
import FileUpload from "./fileUpload/FileUpload";
import CmSwitch from "../../../../../../components/CmSwitch/CmSwitch";

class PriceInput extends Component {

    render() {
        const {configType, configValue, onChange,placeholder} = this.props;
        return (
            <>
                {
                    configType === 1 ?
                        <Input placeholder={placeholder} value={configValue}
                               onChange={e => onChange(e.target.value)}/> : <></>
                }
                {
                    configType === 2 ?
                        <Input placeholder={placeholder} value={configValue}
                               onChange={e => onChange(e.target.value)}/> : <></>
                }
                {
                    configType === 3 ?
                        <ImgUpload
                            value={configValue}
                            onChange={onChange}
                        /> : <></>
                }
                {
                    configType === 4 ?
                        <FileUpload
                            value={configValue}
                            onChange={onChange}
                        /> : <></>
                }
                {
                    configType === 5 ?
                        <Switch
                            checked={configValue === "true"}
                            checkedChildren="开"
                            unCheckedChildren="关"
                            onChange={checked => onChange(checked ? "true" : "false")}
                        /> : <></>
                }
                {
                    configType === 6 ?
                        <Input placeholder={placeholder} value={configValue}
                               onChange={e => onChange(e.target.value)}
                        /> : <></>
                }

            </>

        );
    }

}

export default PriceInput;